function addedToCart(addedItem) {
    //request cart information from /cart.js endpoint
    fetch(`${window.location.origin}/cart.js`)
        .then((resCart) => {
            if (!resCart.ok) {
                console.error(`[klaviyo add to cart] Failed to fetch cart: ${resCart.status} ${resCart.statusText}`);
                return;
            }
            return resCart.json();
        })
        .then((data) => {
            if (!data) return;
            let eventProperties = {
                total_price: data.total_price / 100,
                $value: data.total_price / 100,
                total_discount: data.total_discount,
                original_total_price: data.original_total_price / 100,
                items: data.items
            };
            let item = window.item || {};
            //item is set in our VP snippet on Shopify product pages
            //if item is set (i.e code is executing on a product page), then use that item object
            if (Object.keys(item).length !== 0) {
                eventProperties = Object.assign(eventProperties, item);
            }
            //if code executing on a page without the VP snippet (i.e executing on Collections page)
            //then build formattedItem object
            else {
                let formattedItem = {
                    "Name": addedItem.title,
                    "ProductID": addedItem.id,
                    "ImageURL": addedItem.image,
                    "URL": `${window.location.origin}${addedItem.url}`,
                    "Brand": addedItem.vendor,
                    "Price": addedItem.price / 100
                };
                eventProperties = Object.assign(eventProperties, formattedItem);
            }
            let targetUrl = window.location.href.includes('/collections/') ? addedItem.url : (addedItem.items?.[0]?.url ?? addedItem.url);

            //grab variant level data from the JSON of the product page
            return fetch(`${window.location.origin}${targetUrl.split("?")[0]}.json`)
                .then((resVariant) => {
                    if (!resVariant.ok) {
                        console.error(`[klaviyo add to cart] Failed to fetch variant: ${resVariant.status} ${resVariant.statusText}`);
                        return;
                    }
                    return resVariant.json();
                })
                .then((data) => {
                    if (!data) return;
                    eventProperties["variant_id"] = addedItem.id;
                    let variantInfo = {};
                    if (data.product && Array.isArray(data.product.variants)) {
                        for (let variantIdx in data.product.variants) {
                            if (data.product.variants[variantIdx].id == addedItem.id) {
                                variantInfo = data.product.variants[variantIdx];
                                break;
                            }
                        }
                    }
                    eventProperties["variant"] = variantInfo;
                    if (typeof klaviyo !== "undefined" && typeof klaviyo.track === "function") {
                        // console.log("[klaviyo add to cart] Klaviyo: Added to Cart event triggered with properties:", eventProperties);
                        klaviyo.track("Added to Cart", eventProperties);
                    } else {
                        console.warn("[klaviyo add to cart] Klaviyo is not defined. 'Added to Cart' event not tracked.");
                    }
                });
        })
        .catch((error) => {
            console.error("[klaviyo add to cart] Error in addedToCart:", error);
        });
}

// URL substring to monitor for
const urlSubstringToMonitor = "/cart/add.js";

// Listener in case of Fetch requests
(function (ns, fetch) {
    try {
        ns.fetch = function () {
            let url = "";
            const response = fetch.apply(this, arguments);

            response.then((resATC) => {
                url = resATC.url;

                // Check if the URL contains the substring we are monitoring
                if (!url.includes(urlSubstringToMonitor)) {
                    // console.log("[klaviyo add to cart] Fetch request URL does not match the monitored substring:", url);
                    return response; // If not, return the original response
                }
                // Ensure the response is not empty before attempting to parse it
                if (!resATC.ok) {
                    // console.error("[klaviyo add to cart] Fetch failed with status:", resATC.status);
                    return null; // Return null if the fetch fails
                }

                // Clone the response so we can read it multiple times
                const clonedResponse = resATC.clone();

                // Check for empty response body
                return clonedResponse.text().then((bodyText) => {
                    if (!bodyText.trim()) {
                        // console.error("[klaviyo add to cart] Empty response body");
                        return null; // Return null if the body is empty
                    }

                    // Try to parse the JSON response
                    try {
                        return JSON.parse(bodyText);
                    } catch (e) {
                        // console.error("[klaviyo add to cart] JSON parse error:", e);
                        return null; // Return null if JSON parsing fails
                    }
                });
            })
                .then((data) => {
                    if (!data) return; // Early return if data is null

                    if (data && url.includes(urlSubstringToMonitor)) {
                        // console.log("[klaviyo add to cart] Fetch request completed:", url);

                        // Check if data.items exists and is an array
                        if (data && Array.isArray(data.items) && data.items.length > 0) {
                            addedToCart(data.items[0]);
                        } else {
                            console.error("[klaviyo add to cart] No items found in the response data");
                        }
                    }
                })
                .catch((error) => {
                    console.error("[klaviyo add to cart] Error processing fetch response:", error);
                });

            return response;
        };
    } catch (error) {
        console.error('[klaviyo add to cart] Unexpected error occurred:', error);
    }
}(window, window.fetch));

// Listener in case of jQuery requests
// KL support recommends disabling this to prevent sending duplicate events 
// if (typeof window.jQuery !== "undefined") {
//     $(document).ajaxComplete(function (event, request, settings) {
//         if (settings.url.includes(urlSubstringToMonitor)) {
//             console.log("[klaviyo add to cart] Ajax request completed:", settings.url);
//             addedToCart(request.responseJSON)
//         }
//     });
// }

// Listener in case of XHR requests
let oldXHR = window.XMLHttpRequest;
function newXHR() {
    let realXHR = new oldXHR();
    realXHR.addEventListener("load", function () {
        if (realXHR.readyState == 4 && realXHR.status == 200) {
            if (realXHR.responseURL.includes(urlSubstringToMonitor)) {
                try {
                    // console.log("[klaviyo add to cart] XHR request completed:", realXHR.responseURL);
                    const responseData = JSON.parse(realXHR.response);
                    // Check if responseData.items exists and is an array
                    if (responseData && Array.isArray(responseData.items) && responseData.items.length > 0) {
                        // console.log("[klaviyo add to cart] Item found in XHR response:", responseData.items[0]);
                        addedToCart(responseData.items[0]);
                    } else {
                        console.error("[klaviyo add to cart] No items found in XHR response data");
                    }
                } catch (error) {
                    console.error("[klaviyo add to cart] Failed to parse XHR response:", error);
                }
            }
        }
    }, false);
    return realXHR;
}
window.XMLHttpRequest = newXHR;